import * as actionTypes from '../actions/actionTypes';

export default function adminPanelTabReducer(state = 0, action) {
  switch(action.type){
    case actionTypes.SET_ADMIN_TAB_INDEX: {
      return action.index
    }
    default:
      return state
   }
}



// WEBPACK FOOTER //
// ./src/components/Admin/reducers/adminPanelTabReducer.js